import apiClient from './client';

export async function getTiers() {
  const res = await apiClient.get('/api/v1/tiers');
  return res.data;
}

export async function getMyTier() {
  const res = await apiClient.get('/api/v1/tiers/me');
  return res.data;
}